import React from "react";
import PropTypes from "prop-types";
import css from "../../css/listing/description.module.css";

class Description extends React.PureComponent {
    render() {
        const { listing } = this.props;

        const description = listing.description.split("\n").map((item, key) => {
            return <p key={key}>{item}</p>;
        });

        return <div className={css.description}>{description}</div>;
    }
}

Description.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default Description;
